"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var markItemsJunkNotJunkFromTable_1 = require("./markItemsJunkNotJunkFromTable");
var markConversationsJunkNotJunkFromTable_1 = require("./markConversationsJunkNotJunkFromTable");
/**
 * Mark the rows as junk or not junk
 * @param rowKeys of the rows to be marked as junk/not junk
 * @param tableView that contains the rows
 * @param isJunkValueToSet whether to mark as junk or not junk
 * @param actionSource the action source
 */
function markRowsJunkNotJunkFromTable(rowKeys, tableView, isJunkValueToSet, actionSource) {
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            markConversationsJunkNotJunkFromTable_1.default(rowKeys, tableView, isJunkValueToSet, actionSource);
            break;
        case 1 /* Message */:
            markItemsJunkNotJunkFromTable_1.default(rowKeys, tableView, isJunkValueToSet, actionSource);
            break;
    }
}
exports.default = markRowsJunkNotJunkFromTable;
//# sourceMappingURL=markRowsJunkNotJunkFromTable.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/markRowsJunkNotJunkFromTable.js
// module id = 5654
// module chunks = 62